module.exports = __webpack_public_path__ + "img/arrow-right-grey.09cebb23.svg";